/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AccountsModule
 */

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { TenantConfiguration as TenantConfigurationObjectType } from 'object-types';
import { IQuotaConfig, ITenantConfiguration } from 'generated-types';

type TTenantConfigurationPartial = Omit<ITenantConfiguration, 'license_quota'>;

export interface ITenantConfigurationConfig extends TTenantConfigurationPartial {
    license_quota?: MessageItem<IQuotaConfig>,
}

/**
 * @description Tenant Config Settings ConfigItem.
 * @author Suraj Kumar
 */
export class TenantConfigurationConfigItem extends MessageItem<ITenantConfigurationConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: TenantConfigurationObjectType,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Getter for license_quota.
     */
    public get licenseQuotaConfig(): IQuotaConfig {
        return this.config.license_quota.config;
    }

    /** @override */
    protected requiredFields(): string[] {
        return ['license_quota'];
    }
}
